import React from "react";
import { Col, Progress, Row } from "antd";
import styles from "../commentStarProgress/commentStarProgress.module.css";
import "./starProgress.css";
type Props = {
  percent: number;
  showInfo?: boolean;
  status?: "normal" | "exception" | "active" | "success" | undefined;
  strokeColor?: string;
  type?: "circle" | "line" | "dashboard" | undefined;
  size?: number | [number, number] | "small" | "default";
  style?: React.CSSProperties | undefined;
  icon?: any;
  number?: number | undefined;
};

const StarProcess = ({
  showInfo = true,
  status,
  percent,
  strokeColor,
  type,
  size = "default",
  style = {
    width: "100%",
    color: "#3a393a",
    fontWeight: 700,
  },
  icon,
  number,
}: Props) => {
  if (showInfo) {
    return (
      <div id="startProgress_wrapper" className={styles.progressWrapper}>
        <div className={styles.progressWrapper_star}>
          <span className={styles.numberStar}>{number}</span>
          <span className={styles.iconStar}>{icon}</span>
        </div>
        <div className={styles.progressWrapper_progress}>
          <Progress
            percent={percent}
            gapPosition="left"
            status={status}
            strokeColor={strokeColor}
            type={type}
            size={size}
            style={{ ...style }}

            // showInfo={false}
          />
          {/* <Progress percent={30} /> */}
        </div>
      </div>
    );
  } else {
    return <Progress />;
  }
};

export default StarProcess;
